import { Config } from '@packages/shared/interfaces';
import { HttpClientBuilder } from '../HttpClientBuilder';

export const createDefaultHttpClient = (config: Config) => {
  return new HttpClientBuilder(config.services.baseUrl).addRequestId().getResult();
};
